export const defaultResizer={}

export const resizer600 = {
    transform:'scale('+Math.min(1,window.innerWidth/600)+')',
    transformOrigin:'top right 0px',
    display:'block',
    width:window.innerWidth/Math.min(1,window.innerWidth/600),
    maxWidth : '1100px'
}

export const resizer800 = {
    transform:'scale('+Math.min(1,window.innerWidth/800)+')',
    transformOrigin:'top right 0px',
    display:'block',
    width:window.innerWidth/Math.min(1,window.innerWidth/800),
    maxWidth : '1100px'
}


export const resizer1100 = {
    transform:'scale('+Math.min(1,window.innerWidth/1100)+')',
    transformOrigin:'top right 0px',
    display:'block',
    width:window.innerWidth/Math.min(1,window.innerWidth/1100),    
    maxWidth : '1300px'
}